'use client';

import { useTranslations } from 'next-intl';

import { EntitySearchInterface } from '@/components/EntitySearch/EntitySearchInterface';
import type { Meilisearch_Relieur } from '@/lib/api/meilisearch-types';
import { Env } from '@/lib/Env';

import { RelieurCard } from '../oldrecherche/components/widgets/RelieursHits';

export function RelieursPageClient() {
  const t = useTranslations('Pages.TousLesRelieurs');

  return (
    <EntitySearchInterface<Meilisearch_Relieur>
      apiKey={Env.NEXT_PUBLIC_MEILISEARCH_KEY}
      indexName="relieurs"
      entityType="relieurs"
      searchPlaceholder={
        t('placeholder_recherche') || 'Rechercher un éditeur par nom...'
      }
      filtersConfig={[]}
      renderHitCard={(hit) => <RelieurCard relieur={hit} />}
      customNoResultsMessages={{
        titre: t('aucun_resultat') || 'Aucun éditeur trouvé',
        message:
          t('aucun_resultat_message') ||
          "Essayez d'élargir votre recherche en modifiant les filtres.",
      }}
      linkToGlobalSearchOnNoResults={false}
    />
  );
}
